var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import './styles/tailwind.css';
import './i18n'; // Inicializa o i18next (deteccao de idioma) antes do render.
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import './index.css';
import App from './App';
import store from './store/store';
// import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
Sentry.init({
    dsn: "https://bf9e3749ded44c3f9a7a972d92bfae83@o4507996398747648.ingest.us.sentry.io/4507999617941504",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost",
        "sdk.idcerberus.com",
        "byecar.idcerberus.com",
        "digito-pay-pj.idcerberus.com",
        "digito-pay.idcerberus.com",
        "prime-precatorios.idcerberus.com",
        "digito-pay-liveness.idcerberus.com",
        "digitopaypf.idcerberus.com",
        "digitopaypj.idcerberus.com",
        "digitopay-pj.idcerberus.com",
        "digitopay-pf.idcerberus.com",
        "sdk-dev.idcerberus.com",
        "byecar-dev.idcerberus.com",
        "byecar-hml.idcerberus.com",
        "sdk-hml.idcerberus.com",
        "digito-pay-dev.idcerberus.com",
        "digito-pay-hml.idcerberus.com"],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
// Patch getUserMedia globally
(function patchGetUserMedia() {
    var _this = this;
    var _a;
    if (!((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia))
        return;
    var originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function (constraints) { return __awaiter(_this, void 0, void 0, function () {
        var stream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.warn('Camera access attempt detected!', constraints);
                    return [4 /*yield*/, originalGetUserMedia(constraints)];
                case 1:
                    stream = _a.sent();
                    console.log('global -> stream: ', stream);
                    window.__lastCameraStream = stream;
                    return [2 /*return*/, stream];
            }
        });
    }); };
})();
export var stopLastCameraStream = function () {
    var stream = window.__lastCameraStream;
    if (stream) {
        stream.getTracks().forEach(function (track) { return track.stop(); });
        window.__lastCameraStream = undefined;
        console.log('Camera stream stopped.');
    }
};
var BasicComponent = /** @class */ (function (_super) {
    __extends(BasicComponent, _super);
    function BasicComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasicComponent.prototype.render = function () {
        return (React.createElement(React.StrictMode, null,
            React.createElement(Provider, { store: store },
                React.createElement(App, null))));
    };
    return BasicComponent;
}(React.Component));
export default BasicComponent;
ReactDOM.render(React.createElement(BasicComponent, null), document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
